import { TrackDef } from '../track.js';

/**
 * TEMPEST ARC — Stormline, advanced.
 * Flat-out commitment above a gas giant: a 100m climb to an open crest ledge
 * with no left wall, a screaming dive into a platform-to-platform long jump,
 * and a fast ess over the void where the right edge simply isn't there.
 */
export const tempest: TrackDef = {
  id: 'tempest',
  name: 'Tempest Arc',
  tagline: 'No walls, no brakes, no floor — just you and the eyewall.',
  environment: 'stormline',
  difficulty: 3,
  layout: 'circuit',
  defaultLaps: 3,
  width: 28,
  unlockLevel: 7,
  points: [
    { x: 0, y: 90, z: 0, width: 30 },
    { x: 30, y: 112, z: 285, width: 30 },
    { x: 150, y: 132, z: 555, width: 28, roll: -0.3 },
    { x: 400, y: 148, z: 710, width: 26, roll: -0.45 },
    { x: 670, y: 144, z: 745, width: 26, roll: -0.4 },
    { x: 930, y: 126, z: 640, width: 28, roll: -0.4 },
    { x: 1110, y: 100, z: 420, width: 28, roll: -0.3 },
    { x: 1210, y: 76, z: 150, width: 30, roll: -0.15 },
    { x: 1225, y: 56, z: -140, width: 32 },
    { x: 1205, y: 42, z: -430, width: 32, roll: -0.3 },
    { x: 960, y: 36, z: -620, width: 26, roll: -0.4 },
    { x: 700, y: 34, z: -700, width: 26, roll: -0.35 },
    { x: 460, y: 42, z: -610, width: 26, roll: 0.4 },
    { x: 250, y: 50, z: -690, width: 26, roll: -0.4 },
    { x: 40, y: 60, z: -480, width: 28, roll: -0.35 },
    { x: -120, y: 78, z: -260, width: 30, roll: -0.3 },
  ],
  features: [
    { kind: 'boost', s: 0.02, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.18, length: 0.12, name: 'eyewall' },
    { kind: 'noWalls', s: 0.2, length: 0.11, side: 'left' },
    { kind: 'boost', s: 0.4, length: 0.007, lane: -0.2 },
    { kind: 'zone', s: 0.45, length: 0.07, name: 'platforms' },
    { kind: 'jump', s: 0.47, length: 0.011 },
    { kind: 'boost', s: 0.66, length: 0.007, lane: 0.2 },
    { kind: 'noWalls', s: 0.71, length: 0.08, side: 'right' },
    { kind: 'boost', s: 0.89, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 59.6, silver: 51.4, gold: 45.9, author: 42.6 },
};
